"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function SpeechBubble(props) {
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24" }, props),
        React.createElement("path", { d: "M12 2c5.451 0 10 3.974 10 9 0 .323-.021.638-.057.945-.558 5.17-5.24 8.773-7.402 10.16L13 23.094v-3.196c-.335.033-.654.102-1 .102-5.451 0-10-3.974-10-9s4.549-9 10-9zm0 2c-4.49 0-8 3.19-8 7s3.51 7 8 7c.615 0 1.217-.067 1.803-.186L15 17.572v1.512c2.048-1.64 4.61-4.153 4.955-7.354l.002-.003A6.38 6.38 0 0 0 20 11c0-3.81-3.51-7-8-7zm1.987 8c.46 0 .831.447.831 1 0 .553-.371 1-.831 1H8.65c-.46 0-.832-.447-.832-1 0-.553.372-1 .832-1h5.337zm1.252-4a1 1 0 1 1 0 2H8.82a1 1 0 1 1 0-2h6.42z", fill: props.color || "#000", fillRule: "nonzero" })));
}
exports.default = SpeechBubble;
